
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMainIconClc = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M107.25 25.006c-.353.792-.518 1.562-.97 2.097-1.03 1.219-2.096 2.449-3.334 3.45-3.584 2.896-7.27 5.673-10.9 8.514-2.946 2.307-5.92 4.59-8.436 7.371a31.9 31.9 0 0 0-2.716 3.476c-.938 1.383-.966 2.846-.295 4.428 1.575 3.71 3.517 7.227 5.503 10.725 5.49 9.669 10.804 19.43 15.697 29.41.907 1.85 1.526 3.839 2.27 5.768.077.199.119.417.137.63.089 1.055-.4 1.663-1.439 1.462-1.137-.219-2.308-.564-3.307-1.128-2.465-1.389-4.868-2.89-7.243-4.424-7.679-4.962-15.33-9.964-23-14.937-3.107-2.015-6.305-3.873-9.749-5.284-2.616-1.072-5.317-1.662-8.175-1.417-2.167.185-4.17.881-6.109 1.803-3.483 1.657-6.617 3.864-9.693 6.141-6.155 4.558-12.259 9.18-18.404 13.749-1.325.985-2.725 1.873-4.115 2.767a8.46 8.46 0 0 1-1.752.868c-.948.331-1.593-.158-1.45-1.138.117-.8.363-1.6.665-2.354 1.623-4.047 3.224-8.104 4.943-12.111 2.759-6.429 5.63-12.811 8.402-19.235.991-2.298 1.838-4.648 2.355-7.115.6-2.866-.21-5.134-2.684-6.734-1.385-.895-2.86-1.657-4.305-2.46-1.027-.57-2.082-1.093-3.106-1.67a14.312 14.312 0 0 1-1.64-1.067c-1.647-1.252-1.556-2.762.328-3.606a79.65 79.65 0 0 1 6.56-2.575c3.42-1.18 6.884-2.225 10.315-3.37 1.279-.427 2.519-.97 3.775-1.464 3.235-1.272 5.79-3.412 7.653-6.265 1.844-2.824 3.457-5.793 5.215-8.673.833-1.364 1.68-2.736 2.69-3.97.578-.706 1.428-1.285 2.273-1.668 1.6-.726 2.748-.398 3.81.985.682.89 1.25 1.87 1.835 2.83 1.08 1.773 2.103 3.582 3.21 5.338.997 1.576 2.468 2.582 4.312 2.917 1.194.217 2.446.398 3.64.283 3.822-.37 7.636-.827 11.438-1.36 5.961-.835 11.904-1.806 17.869-2.617 1.632-.221 3.317-.131 4.973-.075.673.024 1.387.245 1.986.556.401.208.634.734.968 1.15z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg  width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n      <path\r\n        fill-rule=\"evenodd\"\r\n        clip-rule=\"evenodd\"\r\n        d='M107.25 25.006c-.353.792-.518 1.562-.97 2.097-1.03 1.219-2.096 2.449-3.334 3.45-3.584 2.896-7.27 5.673-10.9 8.514-2.946 2.307-5.92 4.59-8.436 7.371a31.9 31.9 0 0 0-2.716 3.476c-.938 1.383-.966 2.846-.295 4.428 1.575 3.71 3.517 7.227 5.503 10.725 5.49 9.669 10.804 19.43 15.697 29.41.907 1.85 1.526 3.839 2.27 5.768.077.199.119.417.137.63.089 1.055-.4 1.663-1.439 1.462-1.137-.219-2.308-.564-3.307-1.128-2.465-1.389-4.868-2.89-7.243-4.424-7.679-4.962-15.33-9.964-23-14.937-3.107-2.015-6.305-3.873-9.749-5.284-2.616-1.072-5.317-1.662-8.175-1.417-2.167.185-4.17.881-6.109 1.803-3.483 1.657-6.617 3.864-9.693 6.141-6.155 4.558-12.259 9.18-18.404 13.749-1.325.985-2.725 1.873-4.115 2.767a8.46 8.46 0 0 1-1.752.868c-.948.331-1.593-.158-1.45-1.138.117-.8.363-1.6.665-2.354 1.623-4.047 3.224-8.104 4.943-12.111 2.759-6.429 5.63-12.811 8.402-19.235.991-2.298 1.838-4.648 2.355-7.115.6-2.866-.21-5.134-2.684-6.734-1.385-.895-2.86-1.657-4.305-2.46-1.027-.57-2.082-1.093-3.106-1.67a14.312 14.312 0 0 1-1.64-1.067c-1.647-1.252-1.556-2.762.328-3.606a79.65 79.65 0 0 1 6.56-2.575c3.42-1.18 6.884-2.225 10.315-3.37 1.279-.427 2.519-.97 3.775-1.464 3.235-1.272 5.79-3.412 7.653-6.265 1.844-2.824 3.457-5.793 5.215-8.673.833-1.364 1.68-2.736 2.69-3.97.578-.706 1.428-1.285 2.273-1.668 1.6-.726 2.748-.398 3.81.985.682.89 1.25 1.87 1.835 2.83 1.08 1.773 2.103 3.582 3.21 5.338.997 1.576 2.468 2.582 4.312 2.917 1.194.217 2.446.398 3.64.283 3.822-.37 7.636-.827 11.438-1.36 5.961-.835 11.904-1.806 17.869-2.617 1.632-.221 3.317-.131 4.973-.075.673.024 1.387.245 1.986.556.401.208.634.734.968 1.15z'\r\n        fill='var(--theme-primary, #810ea9)'\r\n      />\r\n    </svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/main-icon_clc.ec6daace963ac2ba4aae552ed1d2bad8.svg"),
        {
          React: SvgMainIconClc,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      